export default "__VITE_ASSET__CVu80AYx__"